import { useState } from 'react';
import { Database, PackageOpen, Users, Building2, Cog, Briefcase, Warehouse, Calendar } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ItemMaster from './masters/ItemMaster';
import BomMaster from './masters/BomMasterNew';
import SourcingMaster from './masters/SourcingMaster';
import CustomerMaster from './masters/CustomerMaster';
import VendorMaster from './masters/VendorMaster';
import MachineMaster from './masters/MachineMaster';
import SkillMaster from './masters/SkillMaster';
import CustomerCalendarMaster from './masters/CustomerCalendarMaster';

const MastersManagement = () => {
  const [activeTab, setActiveTab] = useState('items');

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-blue-50 to-slate-100 p-6 rounded-lg border border-blue-200">
        <div className="flex items-center gap-3 mb-2">
          <Database className="w-6 h-6 text-blue-600" />
          <h2 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Master Data Management</h2>
        </div>
        <p className="text-slate-600">Manage all master data including items, BOMs, sourcing (SOB%), vendors, customers, and resources</p>
      </div>

      <Card data-testid="masters-tabs-card" className="shadow-lg">
        <CardContent className="pt-6">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="grid w-full grid-cols-8 mb-6">
              <TabsTrigger data-testid="tab-items" value="items">
                <PackageOpen className="w-4 h-4 mr-2" />
                Items
              </TabsTrigger>
              <TabsTrigger data-testid="tab-bom" value="bom">
                <Database className="w-4 h-4 mr-2" />
                BOM
              </TabsTrigger>
              <TabsTrigger data-testid="tab-sourcing" value="sourcing">
                <Briefcase className="w-4 h-4 mr-2" />
                Sourcing/SOB%
              </TabsTrigger>
              <TabsTrigger data-testid="tab-customers" value="customers">
                <Users className="w-4 h-4 mr-2" />
                Customers
              </TabsTrigger>
              <TabsTrigger data-testid="tab-calendar" value="calendar">
                <Calendar className="w-4 h-4 mr-2" />
                Cust. Calendar
              </TabsTrigger>
              <TabsTrigger data-testid="tab-vendors" value="vendors">
                <Building2 className="w-4 h-4 mr-2" />
                Vendors
              </TabsTrigger>
              <TabsTrigger data-testid="tab-machines" value="machines">
                <Cog className="w-4 h-4 mr-2" />
                Machines
              </TabsTrigger>
              <TabsTrigger data-testid="tab-skills" value="skills">
                <Warehouse className="w-4 h-4 mr-2" />
                Skills
              </TabsTrigger>
            </TabsList>

            <TabsContent value="items" data-testid="tab-content-items">
              <ItemMaster />
            </TabsContent>

            <TabsContent value="bom" data-testid="tab-content-bom">
              <BomMaster />
            </TabsContent>

            <TabsContent value="sourcing" data-testid="tab-content-sourcing">
              <SourcingMaster />
            </TabsContent>

            <TabsContent value="customers" data-testid="tab-content-customers">
              <CustomerMaster />
            </TabsContent>

            <TabsContent value="calendar" data-testid="tab-content-calendar">
              <CustomerCalendarMaster />
            </TabsContent>

            <TabsContent value="vendors" data-testid="tab-content-vendors">
              <VendorMaster />
            </TabsContent>

            <TabsContent value="machines" data-testid="tab-content-machines">
              <MachineMaster />
            </TabsContent>

            <TabsContent value="skills" data-testid="tab-content-skills">
              <SkillMaster />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default MastersManagement;
